import './footer.css';
import FooterLogo from '../../assets/quantum/IYQST-horiz-rgb.png';

export const Footer = () => {
  return (
    <footer className="snn-footer-wrapper">
      <div className="snn-footer-section-wrapper">
        <div className="snn-footer-section">
          <h2 className="snn-section-title">Simposio</h2>
          <p className="snn-section-item">Acerca de</p>
          <p className="snn-section-item">Aviso de privacidad</p>
        </div>
        <div className="snn-footer-section">
          <h2 className="snn-section-title">Contactanos</h2>
          <p>contacto@quantum2025.mx</p>
        </div>
      </div>
      <div className="snn-footer-logo-wrapper">
        <img src={FooterLogo}
          className="footer-logo-wrapper-svg"
          alt="Symposium of Nanoscience and Nanomaterials logo"
        />
      </div>
    </footer>
  );
};
